import * as React from "react";
import { Tabs, Tab } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EditIcon from "@mui/icons-material/Edit";
import HearingIcon from "@mui/icons-material/Hearing";
import { Icon } from "@iconify/react";

export default function SubSectionData({
  tabs = [],
  selected = 0,
  onChange = () => {},
}) {
  const getIcon = (name) => {
    switch (name.toLowerCase()) {
      case "reading":
        return <MenuBookIcon style={{ fontSize: 18, marginRight: 6 }} />;
      case "writing":
        return <EditIcon style={{ fontSize: 18, marginRight: 6 }} />;
      case "speaking":
        return (
          <Icon
            icon="mingcute:mic-2-fill"
            style={{ fontSize: 18, marginRight: 6 }}
          />
        );
      case "listening":
        return <HearingIcon style={{ fontSize: 18, marginRight: 6 }} />;
      default:
        return null;
    }
  };

  return (
    <Tabs
      value={selected}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      TabScrollButtonProps={{
        sx: {
          "&.Mui-disabled": {
            display: "none", // hide disabled scroll buttons completely
          },
        },
      }}
      sx={{
        minHeight: 0,
        "& .MuiTab-root": {
          minWidth: 120,
          padding: "4px 12px",
          borderRadius: 2,
          alignItems: "center",
          textTransform: "none",
          fontSize: 12,
          fontFamily: "Inter",
          fontWeight: 600,
          color: "#333",
          minHeight: "32px",
        },
        "& .Mui-selected": {
          backgroundColor: "#F9EEFF",
          color: "#9D0385 !important",
          fontWeight: 700,
          minHeight: "32px",
        },

        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          icon={getIcon(tab.name)}
          iconPosition="start"
          label={tab.name}
        />
      ))}
    </Tabs>
  );
}
